import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Tab from '@mui/material/Tab';
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import { Link } from "react-router-dom";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import { Button,Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ProductFilter from "../components/ProductFilter";
import FirmwareModal from "../components/FirmwareModal";
import AccessDeniedImg from '../assets/access_denied.png';
import LoaderComponent from "../components/LoaderComponent";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { connect, useDispatch, useSelector } from "react-redux";
import FirmwareHistoryItem from "../components/FirmwareHistoryItem";
import { loadControllersList } from "../api/controllerpermissionsapi";
import { uploadFirmware,loadFirmwareHistory} from "../api/managefileapi";
import { openFirmwareDialog,closeFirmwareDialog } from "../state/files/actions";
import { getFilesLoading,getFirmwaresData,getFirmwareDialogStatus, getControllersList} from "../selector/selectors";

function ManageFirmware({
  isLoading,
  uploadFirmware,
  startLoadingFirmwareHistory,
  firmwareList,
  firmwareDialogBoxStatus,
  controllersList
}) {
  const navigate = useNavigate();
  const list     = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);
  
  let roleAccessDenied = false;
  let userAccessDenied = false;
  list?.data?.rolePermissions?.map(rp => rp.key_name === 'manageFirmware' ? roleAccessDenied = true : roleAccessDenied);
  list?.data?.userPermissions?.map(up => up.key_name === 'manageFirmware' ? userAccessDenied = true : userAccessDenied);
  const dispatch = useDispatch();
  const [firmwareFile, setFirmwareFile]       = useState('');
  const [value, setValue]                     = useState('1');
  const [controllersData, setControllersData] = useState([]);
  const [controller, setController]           = useState('');
  const [firmwareData, setFirmwareData]       = useState({
    version : '',
    releaseNotes:'',
    controllerId: controllersData[0]?.id
  });
  
  
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const handleClickOpenFirmware = () => {
    document.activeElement.blur();
    dispatch(openFirmwareDialog());
  };


  const handleFormData = () => {
    const formData = new FormData(); 
    if(firmwareData.length === 0 || firmwareData.version === '' || firmwareData.controllerId === '' || firmwareData.releaseNotes === '' || firmwareFile === ''){
      swal("Oops!", "Please fill required fields!", "error");
      return false;
    }
    formData.append('uploadedFile', firmwareFile);
    Object.keys(firmwareData).forEach(key => formData.append(key, firmwareData[key]));
    uploadFirmware(formData);
    if(firmwareDialogBoxStatus === false) {
      dispatch(closeFirmwareDialog());
    }
  }

  const onClickChangeList=(controllerId)=>{
    setController(controllerId);
    startLoadingFirmwareHistory(controllerId);
  }

  
  useEffect(() => {
    if(roleAccessDenied || userAccessDenied){
      startLoadingFirmwareHistory('');
      dispatch(loadControllersList());
    }
    dispatch(closeFirmwareDialog());
    // eslint-disable-next-line
  }, [startLoadingFirmwareHistory]);

  useEffect(() => {
    if (controllersList?.data) {
      setControllersData(controllersList?.data);
    }
  }, [controllersList]);

  useEffect(() => {
    if(firmwareDialogBoxStatus === false) {
      setFirmwareFile('');
      setFirmwareData({
          version : '',
          releaseNotes:'',
          controllerId: controllersData[0]?.id
      });
    }
  }, [firmwareDialogBoxStatus,controllersData]);

 
  const handleSearchControllers = (event) => {
    if(event.target.value !== ''){
      setControllersData(controllersList?.data?.filter(controller => controller.controller_name.match(event.target.value.toUpperCase())));
    } else {
      setControllersData(controllersList?.data);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }} >
      { isLoading &&  (roleAccessDenied || userAccessDenied) ?  <LoaderComponent />: <></>}
      <Grid container >
        <TabContext value={value}>
          <Grid item xs={12} md={12} lg={12} >
            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
              <TabList onChange={handleChange} aria-label="">
                <Tab label="Firmware" value="1" />
                <Link className="tabingLinks" to="/web/config-files">Config file history</Link>
                <Link className="tabingLinks" to="/web/default-files">Default Configuration</Link>
                <Link className="tabingLinks" to="/web/event-logs">Event logs</Link>
              </TabList>
            </Box>
            <TabPanel value="1" sx={{p:0,pt:2}}>  
            {(roleAccessDenied || userAccessDenied)  &&
              <><Grid container sx={{ paddingBottom: 1, display: 'flex', justifyContent: 'space-between' }}>
                  <Grid>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 2 }}>
                      <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                      <TextField id="input-with-sx" label={'Search Controllers'} variant="standard" onChange={handleSearchControllers} />
                    </Box>
                    <ProductFilter controllersList={controllersData} onClickChangeList={onClickChangeList} selectedControllerId={controller} />
                  </Grid>
                  <Grid>
                    <Button
                      variant="contained"
                      size="medium"
                      color="primary"
                      onClick={handleClickOpenFirmware}
                    >
                      <CloudUploadIcon fontSize="medium" sx={{ paddingRight: 1 }} /> Upload
                    </Button>
                  </Grid>
                </Grid><FirmwareHistoryItem firmwareList={firmwareList?.data} /></>
            }
            {(roleAccessDenied === false && userAccessDenied === false)  &&
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                sx={{ minHeight: '80vh' }}
              >
                <img style={{maxWidth:'100%'}} alt="access_denied" src={AccessDeniedImg}  />
                <Typography sx={{paddingBottom:'10px'}} variant="h6">Access Denied</Typography>
                <Typography sx={{paddingBottom:'20px'}} variant="span">You do not have permission to view this page. </Typography>
                <Button onClick={(e)=>{navigate('/web/dashboard')}}  variant="contained">Dashboard</Button>
              </Grid>
            }
            </TabPanel>
          </Grid>
        </TabContext> 
        <FirmwareModal
          open={firmwareDialogBoxStatus}
          value={firmwareData}
          setFirmwareData={setFirmwareData}
          firmwareFile={firmwareFile}
          setFirmwareFile={setFirmwareFile}
          handleFormData={handleFormData}
          controllersList={controllersList?.data}
        />   
      </Grid>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  isLoading: getFilesLoading(state),   
  firmwareList: getFirmwaresData(state),
  firmwareDialogBoxStatus: getFirmwareDialogStatus(state),
  controllersList: getControllersList(state)
});

const mapDispatchToProps = (dispatch) => ({
  uploadFirmware: (data)                => dispatch(uploadFirmware(data)),
  startLoadingFirmwareHistory: (data)   => dispatch(loadFirmwareHistory(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageFirmware);

